export const SUCCESS = "SUCCESS";
export const INFO = "INFO";
export const ERROR = "ERROR";

export const NOT_LOGGED_IN = {
  content: "Merci de vous connecter ou de vous inscrire.",
  color: ERROR,
};
export const SUGGESTION_SUCCESS = {
  content: "Votre suggestion a été envoyé !",
  color: SUCCESS,
};

export const INTERNAL_ERROR = {
  content: "Un problème interne est survenu !",
  color: ERROR,
};

export const LIKED = {
  content: "Votre bien a été enrengistré avec succès !",
  color: SUCCESS,
};

export const WIP = {
  content: "Cette fonctionnalité n'est pas disponible pour le moment",
  color: INFO,
};

export const CONTRACT_NOT_FOUND = {
  content: "Ce contrat n'est pas disponible pour le moment",
  color: ERROR,
};
